import React, { Component } from 'react'
import { Button } from 'react-bootstrap'
import Api from '../Services/Api'
import { toast } from '../Components/ui'
import { FiSave } from 'react-icons/fi'

class Automations extends Component {
  constructor (props) {
    super(props)
    this.state = {
      primaSingolaLimit: 0,
      primaGruppoLimit: 0,
      terzaSingolaLimit: 0,
      terzaGruppoLimit: 0,
      enabledPrima: false,
      enabledTerza: false,
      primaSingola: false,
      primaGruppo: false,
      terzaSingola: false,
      terzaGruppo: false
    }
  }

  async componentDidMount () {
    await this.fetchData()
  }

  async fetchData () {
    const res = await Api.get('/automations/calibrature')
    if (res.ok) {
      const {
        primaSingolaLimit, primaGruppoLimit, terzaSingolaLimit, terzaGruppoLimit,
        enabledPrima, enabledTerza, primaSingola, primaGruppo, terzaSingola, terzaGruppo
      } = res.data
      this.setState({
        primaSingolaLimit, primaGruppoLimit, terzaSingolaLimit, terzaGruppoLimit,
        enabledPrima, enabledTerza, primaSingola, primaGruppo, terzaSingola, terzaGruppo
      })
    }
  }

  async saveAutomations () {
    const {
      primaSingolaLimit, primaGruppoLimit, terzaSingolaLimit, terzaGruppoLimit,
      enabledPrima, enabledTerza, primaSingola, primaGruppo, terzaSingola, terzaGruppo
    } = this.state

    const res = await Api.patch('/automations/calibrature', {
      primaSingolaLimit, primaGruppoLimit, terzaSingolaLimit, terzaGruppoLimit,
      enabledPrima, enabledTerza, primaSingola, primaGruppo, terzaSingola, terzaGruppo
    })
    if (res.ok) {
      toast.success('Le automazioni sono state aggiornate con successo')
    } else {
      toast.error('Impossibile aggiornare le automazioni')
    }
  }

  renderThresholdRow (label, value, onChange, unit = '%') {
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
        <span style={{ flex: 1, fontSize: '0.9rem' }}>{label}</span>
        <input
          type='number'
          value={value}
          onChange={onChange}
          style={{ width: 80, minHeight: 36, borderRadius: 8, border: '1px solid #cfd8cf', padding: '0 10px', textAlign: 'center' }}
        />
        <span style={{ fontSize: '0.9rem', fontWeight: 600 }}>{unit}</span>
      </div>
    )
  }

  renderCheckbox (label, checked, onChange) {
    return (
      <div className='ui-checkbox-row' style={{ marginBottom: 10 }}>
        <input type='checkbox' checked={checked} onChange={onChange} />
        <span>{label}</span>
      </div>
    )
  }

  render () {
    const {
      primaSingolaLimit, primaGruppoLimit, terzaSingolaLimit, terzaGruppoLimit,
      enabledPrima, enabledTerza, primaSingola, primaGruppo, terzaSingola, terzaGruppo
    } = this.state

    return (
      <div>
        <div className='ui-page-header'>
          <h3>Automazioni</h3>
          <Button variant='primary' size='sm' onClick={() => this.saveAutomations()}>
            <FiSave style={{ marginRight: 4 }} /> Salva
          </Button>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24, maxWidth: 900 }}>
          {/* Qualità I */}
          <div style={{ background: 'var(--sf-surface)', border: '1px solid var(--sf-border)', borderRadius: 'var(--sf-radius-sm)', padding: 20 }}>
            <h6 className='ui-form-section-title'>Qualità I</h6>
            {this.renderCheckbox('Abilita notifiche qualità I', enabledPrima, e => this.setState({ enabledPrima: e.target.checked }))}
            {this.renderCheckbox('Notifica singola', primaSingola, e => this.setState({ primaSingola: e.target.checked }))}
            {this.renderCheckbox('Notifica raggruppata', primaGruppo, e => this.setState({ primaGruppo: e.target.checked }))}
            <hr style={{ borderColor: 'var(--sf-border)', margin: '16px 0' }} />
            {this.renderThresholdRow('Soglia singola calibratura (minore di)', primaSingolaLimit, e => this.setState({ primaSingolaLimit: Number(e.target.value) }))}
            {this.renderThresholdRow('Soglia raggruppata (minore di)', primaGruppoLimit, e => this.setState({ primaGruppoLimit: Number(e.target.value) }))}
          </div>

          {/* Qualità III */}
          <div style={{ background: 'var(--sf-surface)', border: '1px solid var(--sf-border)', borderRadius: 'var(--sf-radius-sm)', padding: 20 }}>
            <h6 className='ui-form-section-title'>Qualità III</h6>
            {this.renderCheckbox('Abilita notifiche qualità III', enabledTerza, e => this.setState({ enabledTerza: e.target.checked }))}
            {this.renderCheckbox('Notifica singola', terzaSingola, e => this.setState({ terzaSingola: e.target.checked }))}
            {this.renderCheckbox('Notifica raggruppata', terzaGruppo, e => this.setState({ terzaGruppo: e.target.checked }))}
            <hr style={{ borderColor: 'var(--sf-border)', margin: '16px 0' }} />
            {this.renderThresholdRow('Soglia singola calibratura (maggiore di)', terzaSingolaLimit, e => this.setState({ terzaSingolaLimit: Number(e.target.value) }))}
            {this.renderThresholdRow('Soglia raggruppata (maggiore di)', terzaGruppoLimit, e => this.setState({ terzaGruppoLimit: Number(e.target.value) }))}
          </div>
        </div>
      </div>
    )
  }
}

export default Automations
